import { buildAddress } from './buildAddress';
import { hasValidAddress } from './hasValidAddress';
import { hasValidHours } from './hasValidHours';
import { hasValidPhoneNumbers } from './hasValidPhoneNumbers';

/**
 * Applies fallback values to department data using the default location
 *
 * @param {ADDDepartment} department - Department object with address, hours, contactInformation
 * @param {WidgetLocation} defaultLocation - Default location for fallback values
 * @param {ADDContactInformation} primaryContactInformation - Primary contact info for fallback
 * @returns {ADDDepartment} Department data with fallbacks applied
 */
export const applyDepartmentFallbacks = (
	department,
	defaultLocation,
	primaryContactInformation
) => {
	const { hours, contactInformation } = department;

	let finalAddress = department.address;
	let finalHours = hours;
	let finalContactInformation = contactInformation;

	// Apply fallbacks when data is invalid
	if (!hasValidAddress(buildAddress(department))) {
		finalAddress = {
			address1: defaultLocation.address,
			address2: '',
			address3: '',
			city: defaultLocation.city,
			state: defaultLocation.state,
			zip: defaultLocation.postalCode,
			country: defaultLocation.country
		};
	}
	if (!hasValidHours(hours)) {
		finalHours = defaultLocation.hours;
	}
	if (!hasValidPhoneNumbers(contactInformation)) {
		finalContactInformation = primaryContactInformation;
	}

	return {
		address: finalAddress,
		hours: finalHours,
		contactInformation: finalContactInformation,
		type: department.type,
		label: department.label
	};
};
